import { Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { initCollapses } from 'flowbite';
import { AuthService, LoadingService } from 'shared';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  value = '-';

  constructor(
    private loadingService: LoadingService,
    public authService: AuthService
  ) {
    this.loadingService.stop();
    this.value = this.authService.getUser()?.name ?? '-';
  }

  ngOnInit(): void {
    initCollapses();
  }
}
